import React, {useMemo} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Text from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
interface Props {
  name: string;
  color: string;
}

const CoachingPlanOverviewSkillOption: React.FC<Props> = ({name, color}) => {
  const disableTooltip = useMemo(() => {
    return !name || name.length < 25;
  }, [name]);
  const {root, coloredCircle, titleStyle} = useStyles();
  return (
    <Tooltip
      title={name}
      disableFocusListener={disableTooltip}
      disableHoverListener={disableTooltip}
      disableTouchListener={disableTooltip}>
      <div className={root}>
        <div style={{backgroundColor: color}} className={coloredCircle} />
        <Text component="span" noWrap className={titleStyle}>
          {name}
        </Text>
      </div>
    </Tooltip>
  );
};

const useStyles = makeStyles(() => ({
  coloredCircle: {
    backgroundColor: '#3A84AD',
    borderRadius: 4,
    marginRight: 6,
    height: 8,
    width: 8,
    minWidth: 8,
  },
  root: {
    alignItems: 'center',
    display: 'flex',
    flexFlow: 'row nowrap',
  },
  titleStyle: {
    overflow: 'hidden',
  },
}));

export default CoachingPlanOverviewSkillOption;
